import o from "./getCountryByNationalNumber.js";
function i(n, a) {
  var r = a.nationalNumber,
    e = a.metadata,
    t = e.getCountryCodesForCallingCode(n);
  if (t) return t.length === 1 ? t[0] : o(r, {
    countries: t,
    metadata: e.metadata
  });
}
export { i as default };